var tokenSelect = {

    // Keeps the option picked with the arrow keys inside the scrolled list (Partials/TokenSelect.razor).
    reveal: (id) => {
        let element = document.getElementById(id);
        if (element)
            element.scrollIntoView({block: 'nearest'});
    },

    // Opens the list upwards when it doesn't fit under the field but there is more room above
    // it (below the fixed header). Runs on focus, before Blazor renders the list, so it never
    // shows in the wrong place first. Blazor leaves the data attribute alone: it isn't in its markup.
    place: (select) => {
        let box    = select.querySelector('.token-box').getBoundingClientRect();
        let header = document.querySelector('header');
        let top    = header ? header.getBoundingClientRect().bottom : 0;
        let height = getComputedStyle(select).getPropertyValue('--token-options-height').trim();
        let need   = parseFloat(height) * (height.endsWith('rem') ? parseFloat(getComputedStyle(document.documentElement).fontSize) : 1);
        let below  = window.innerHeight - box.bottom;
        let above  = box.top - top;

        select.dataset.drop = below < need && above > below ? 'up' : 'down';
    }
};

document.addEventListener('focusin', (e) => {
    if (e.target.matches('.token-select .token-input'))
        tokenSelect.place(e.target.closest('.token-select'));
});
